import React, { useState, useEffect } from 'react';
import './Hero.css';
import banner from './Banner.jpg';
import banner1 from './Banner1.jpeg';
// import banner2 from './Banner2.jpeg';
import banner3 from './Banner3.jpg';

const Hero = () => {
  const images = [banner, banner3, banner1]; // Array of images

  return (
    <div className="heroo">
      <div className="slider-container">
        <img src={banner} alt="Banner 1" className="slider-img" />
        <img src={banner3} alt="Banner 4" className="slider-img" />
        <img src={banner1} alt="Banner 2" className="slider-img" />
        {/* <img src={banner2} alt="Banner 3" className="slider-img" /> */}
      </div>

      <div className="dots-container">
        {images.map((_, index) => (
          <div key={index} className="dot"></div>
        ))}
      </div>
    </div>
  );
};

export default Hero;
